<template>
  <div class="col-xl-8 col-md-12">
    <!-- Post -->
    <div class="row mt-2 mb-5 pb-3 mx-2">
      <!-- Card -->
      <div class="card card-body mb-5">
        <h2 class="font-weight-bold mt-3">
          <strong>Advisory Board Members</strong>
        </h2>
        <hr class="red title-hr" />
        <p class="article">
          <span>Prof. Vinod Khadkikar, Khalifa University, UAE</span> <br />
          <span>Prof. Sukumar Mishra, IIT Dhanbad</span> <br />
          <span>Prof. Ashok Pradhan, IIT Kharagapur</span> <br />
          <span>Prof. Vivek Agarwal, Institute Chair Professor, IIT-Bombay</span> <br />
          <span>Prof. Bidyadhar Subudhi, NIT Warangal</span> <br />
          <span>Prof. Ramesh Bansal, University of Pretoria, South Africa</span> <br />
          <span>Dr. Geetam Tomar, Rajkiya Engg. College, Sonbhadra, UP</span> <br />
          <span>Mr. M. K. Badapanda, RRCAT, Indore
          </span>
          <br />
          <span>Prof. Arup Lal Chakraborty, IIT Gandhinagar</span>
          <br />
          <span>Prof. M. V. Aware, NIT Arunachal Pradesh</span> <br />
          <span>Prof. R. K. Nema, MANIT Bhopal
          </span> <br />
          <span>Prof. Shailendra Jain, MANIT Bhopal
          </span> <br />
          <span>Dr. Manisha Dubey, MANIT, Bhopal</span> <br />
          <span>Prof. Mohammad Pazoki, Damghan University, Damghan, Iran</span> <br />
          <span>Prof. Almoataz Y. Abdelaziz, Future University in Egypt, Cairo</span> <br />
          <span>Prof. S. Nema, MANIT Bhopal</span> <br />
          <span>Prof. V T Somashekhar, NIT Warangal</span> <br />
          <span>Dr. Pradyumn Chaturvedi, VNIT Nagpur</span> <br />
        </p>
      </div>
      <!-- entry-content clearfix-->

      <div id="comments" class="comments-area"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Advisory_Committee",
};
</script>
